export default "__VITE_ASSET__CNXbKNk5__"